<template>
  <div class="door-config__coverings">
    <label v-for="(item, indexItem) in groupAndSort" :key="indexItem" class="door-config__cover"
      @click="$emit('clickTab', index, item, indexItem)">
      <input type="radio" :name="index + '_parent'" :checked="activeTabIndex == indexItem" />
      <div class="img__preview" style="max-width: 175px; max-height: 130px">
        <img :src="item?.items[0]?.handlePreview" alt="preview" />
      </div>
      <span>{{ item.collection }}</span>
    </label>
  </div>
</template>
<script>
export default {
  computed: {
    groupAndSort() {
      let { prices, pictureText, ...obj } = this.filter
      return obj
    },
  },
  props: {
    index: [String, Number],
    filter: [Object, Array],
    activeTabIndex: [String, Number],
  },
  emits: ['clickTab'],
};
</script>